import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPersonEnterGreyed = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 26,
	height: 12,
	viewBox: "0 0 26 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_822_3452)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M5.49996 0.5L10.2631 8.75H0.736816L5.49996 0.5Z",
					fill: "#9e9e9e"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M19.7491 6.67783C21.3731 6.67783 22.6895 5.36133 22.6895 3.73735C22.6895 2.11337 21.3731 0.796875 19.7491 0.796875C18.1251 0.796875 16.8086 2.11337 16.8086 3.73735C16.8086 5.36133 18.1251 6.67783 19.7491 6.67783Z",
					stroke: "#9e9e9e",
					strokeWidth: 1.5,
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M15 11.2015C15 8.93964 16.8095 6.67773 19.75 6.67773C22.6905 6.67773 24.5 8.93964 24.5 11.2015",
					stroke: "#9e9e9e",
					strokeWidth: 1.5,
					strokeLinecap: "round",
					strokeLinejoin: "round"
				})
			]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_822_3452",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 26,
				height: 12,
				fill: "white"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgPersonEnterGreyed);
export { ForwardRef as ReactComponent };
